import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("No session_id in URL");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("dh_token", data.token);
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}`);
        // Clean URL and redirect
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Authentication failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-center px-6">
      <div>
        <div className="overline text-accent">Signing you in</div>
        <div className="font-display text-3xl mt-3">
          {error ? "Something went wrong" : "One moment…"}
        </div>
        {error && (
          <div className="mt-4 text-sm text-muted-foreground">
            {error}<br />
            <button onClick={() => navigate("/login")} className="text-accent underline mt-3" data-testid="auth-error-back">
              Back to sign in
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
